import { HttpClient, HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { EventBus, EventBusType, IEventBus } from '@core/event-bus';

import { container } from './index';

// Core modules
container.bind<IHttpClient>(HttpClientType).to(HttpClient);
container.bind<IEventBus>(EventBusType).to(EventBus);
